module.exports = __webpack_public_path__ + "img/tips1_botlist1img6.2b2aaee0.jpg";